mutation LinkSageTransactionRecord(
  $sageJournalEntryId: ID!
  $caseRecordId: ID!
) {
  linkSageTransactionRecord(
    input: {
      sageJournalEntryId: $sageJournalEntryId
      caseRecordId: $caseRecordId
    }
  ) {
    success
  }
}
